// =========================================================
// The release this bundle was built from
// =========================================================
//
// `REACT_APP_RELEASE` is inlined by Create React App at build time from
// the same build-arg the container turns into `APP_RELEASE`, so this
// constant and the release the serving container reports are the same
// string by construction.
//
// Exposed as a function rather than an exported constant for two
// reasons: tests can mock a single module boundary instead of
// manipulating `process.env` (which the production image build sets, so
// env-reading tests would behave differently there than locally), and
// the inlining happens at the one call site below.
//
// Development builds have no build-arg and therefore no release. An
// empty value means "I do not know what I am running", which every
// caller treats as a reason not to act rather than a reason to guess.
export function getOwnRelease(): string {
  return process.env.REACT_APP_RELEASE ?? '';
}
